export default {
  namespaced: true,
  state: {
    accessTokenExpDate: '',
    accessToken : ''
  },

  mutations: {
    SET_ATOKEN_EXP_DATE (state, expDate) {
      state.accessTokenExpDate = expDate
      localStorage.setItem('ACCESS_TOKEN_EXPIRE',expDate)
    },
    SET_ACCESS_TOKEN (state, payload ) {
      state.accessToken = payload
      localStorage.setItem('ACCESS_TOKEN',payload)
    }
  },
  actions : {
    checkAuth({ commit, state }) {
      if( localStorage.getItem('ACCESS_TOKEN') ) {
          state.accessToken = localStorage.getItem('ACCESS_TOKEN')
          return true;
      }
     else return false;     
    }
  }
}
